'use client';

export default function Ping({ pingColor = '#ef4444' }: { pingColor?: string }) {
  return (
    <span className="relative flex h-2 w-2">
      <span
        className="animate-ping absolute inline-flex h-full w-full rounded-full opacity-75"
        style={{ backgroundColor: pingColor }}
      />
      <span
        className="relative inline-flex rounded-full h-2 w-2"
        style={{ backgroundColor: pingColor }}
      />
    </span>
  );
}
